import React,{useEffect,useState,useRef} from "react";
import {connect} from "react-redux";
import {teamSiteUrlFormate} from "../../../utils/dateFormate" ;
import ReactHtmlParser from 'html-react-parser';
//import {ReactComponent as ExchangeVacationIcon} from "../../../design-system/design_system/assets/icons/system/condo.svg";

const DreamSubMenu = (props) => {
    const{subMenuArr, showSubMenu, dreamSubMenuArr}=props;
    const {REACT_APP_IMAGEURL} = window.weeksWebCloudConfig;
        return(
            <div className={`bg-base container-fluid sub-menu-container d-none d-lg-block ${props.showDreamSubMenu && props.showOverlay ? "open" : ""}`}>
                <div className="row px-4">
                    <div className="col-md-3 pt-5">
                       <div className="sub-menu-list-title subtitle">{dreamSubMenuArr.LinksInfo.TitleText}</div>
                       <ul className="sub-menu-list mt-2">
                        {dreamSubMenuArr.LinksInfo.Links.map((data, indexKey)=><li key={indexKey} data-testid={data.HoverText}>
                            <a href={teamSiteUrlFormate(data.URL)} 
                            key={indexKey}
                            aria-label={data.HoverText}
                            target ={data.ExternalIndicator === 2 ? "_blank" : "_self"}
                            >{ReactHtmlParser(data.DisplayText)}</a>
                            </li>)}
                      </ul>
                    </div>
                   
                    <div className="col-md-9 px-8 pt-5">
                        <div className="row">
                        <div className="subtitle col-12 mb-3">{dreamSubMenuArr.ActivityInfo.HeadingText}</div>
                        {
                            dreamSubMenuArr.ActivityInfo.ImageInfo.map((data, index)=>{
                                return(
                                    <div className="col-4" 
                                     key={index}
                                     data-testid={data.HoverText}>
                                    <a href={teamSiteUrlFormate(data.URL)} className="sub-menu-promo-block" key={index}
                                     target ={data.ExternalIndicator === 2 ? "_blank" : "_self"}
                                     aria-label={data.HoverText}>
                                        <img src={REACT_APP_IMAGEURL+data.Image} width="100%" alt={data.TitleText}/>
                                        <p>
                                            {ReactHtmlParser(data.TitleText)}
                                        </p>
                                    </a>
                                    
                                </div>
                                )
                            })
                        }  
                      
                        </div>
                    </div>
                </div>
            </div>
        )
   
        
    }

    
    const mapStateToProps =(state) =>{
        return{
            showOverlay:state.CommonReducer.showOverlay
        }
        
    }


export default connect(mapStateToProps)(DreamSubMenu);